import React, { Component } from 'react';
import './Fields.css'
import Api from '../services/api';
import AuthService from '../services/auth';
import { connect } from 'react-redux';
import * as routes from '../constants/routes';

class SettingsPromoCode extends Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
    };
  }

  componentDidMount() {
    const { ucdUser, setCurrentPage } = this.props;
    if(ucdUser) {
      this.setState({
        email: ucdUser.email,
      });
    }
    setCurrentPage(routes.SETTINGS);
  }

  componentWillReceiveProps(props) {
    const { ucdUser } = props;
    if(ucdUser) {
      this.setState({
        email: ucdUser.email,
      });
    }
  }

  getMaskedEmail() {
    const { email } = this.state;
    const regExp = /[a-zA-Z0-9\-_.+]{3}@/;
    return email.replace(regExp, '***@');
  }

  retrieveRefCode() {
    const { ucdUser } = this.props;
    (new Api()).post(`/users/${ucdUser.id}/refCode`)
      .then((response) => {
        if(response.success) {
          this.refreshCurrentUser();
        }
      });
  }

  refreshCurrentUser() {
    const { authUser, onSetAuthUser } = this.props;
    (new Api()).get('/users/current', {}, AuthService.getAuthCookie())
      .then(response => {
        onSetAuthUser(authUser, response.user);
      });
  }

  render() {
    const { title, ucdUser } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        {ucdUser && ucdUser.accountType === 'sugar_baby' && <form>
          <div className="field-container text">
            <div className="row">
              <div className="col">
                <p className="bold">
                  EARN UP TO &euro;500,- PER MONTH BY BRINGING US PAYING SUGARDADDY’S
                </p>
                <p>
                  Earn €50.- for each SugarDaddy who buys an Elite Membership by using your PROMOCODE.
                </p>
                <p>
                  Request your promocode here. After you request we will take your request into account and get back to you as soon as possible.
                </p>
                {ucdUser && ucdUser.refCode !== 'pending' && ucdUser.refCode !== '' &&
                <p className="field-title bold">Your promocode</p>}
                <p>
                  {ucdUser && ucdUser.refCode === '' && 'I would like to generate the promocode.'}
                  {ucdUser && ucdUser.refCode === 'pending' && 'Your promo code request is pending approval'}
                  {ucdUser && ucdUser.refCode !== 'pending' && ucdUser.refCode !== '' &&
                    ucdUser.refCode}
                </p>
              </div>
              {ucdUser && ucdUser.refCode === '' &&
              <div className="col text-right">
                <button
                  onClick={(e) => {e.preventDefault();this.retrieveRefCode()}}
                >
                  Retrieve reference code
                </button>
              </div>}
            </div>
          </div>
        </form>}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  ...props,
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPromoCode);


// WEBPACK FOOTER //
// ./src/components/SettingsPromoCode.js